import { useField } from 'formik';
import { motion } from 'framer-motion';

interface IAcademiaTextAreaField {
  placeholder: string;
  label: string;
  name: string;
  isRequired?: boolean;
  [key: string]: any;
}

const AcademiaTextAreaField = ({
  name,
  label,
  placeholder,
  isRequired,
  ...props
}: IAcademiaTextAreaField) => {
  // integration of formik hooks here
  const [field, meta] = useField(name);

  // rendering custom text area field component here
  return (
    <div>
      <label
        htmlFor={`input-${name}`}
        title={isRequired ? 'This field is required' : ''}
        className='block mb-1 text-legal-dark-blue font-medium text-base'
      >
        {label} {isRequired && <span className='text-base-red'>*</span>}
      </label>

      <motion.textarea
        initial={{ x: 0 }}
        animate={
          meta.touched && meta.error
            ? {
                x: [0, -100, 0, 100, 0],
                transition: {
                  duration: 0.1,
                  repeat: 2,
                },
              }
            : { x: 0 }
        }
        id={`input-${name}`}
        className={`border-2 focus:ring-4 focus:ring-legal-dark-blue rounded-md p-3 w-full text-legal-dark-blue font-semibold duration-300 text-base min-h-[150px] ${
          meta.touched && meta.error
            ? 'border-base-red'
            : 'border-legal-dark-blue'
        }`}
        placeholder={placeholder}
        autoComplete='off'
        {...field}
        {...props}
      ></motion.textarea>

      <motion.label
        initial={{ y: -20, opacity: 0, display: 'none' }}
        animate={
          meta.touched && meta.error
            ? { y: 0, opacity: 1, display: 'block' }
            : { y: -20, opacity: 0, transitionEnd: { display: 'none' } }
        }
        htmlFor={`input-${name}`}
        className='block mt-1 text-base-red text-base'
      >
        {meta.error}
      </motion.label>
    </div>
  );
};

export default AcademiaTextAreaField;
